<template>
  <el-dialog
    title=""
    :visible.sync="isVisible"
    width="414px"
    center
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <div>
      <el-steps :active="activeStep" align-center>
        <el-step title="验证手机"></el-step>
        <el-step title="设定角色"></el-step>
        <el-step title="分配门店"></el-step>
      </el-steps>

      <div class="inner-wrap">
        <el-scrollbar>
          <!-- 验证手机 -->
          <transition name="login-transform" mode="out-in">
            <el-form v-if="activeStep === 1" ref="dataForm" label-position="top" :model="form" :rules="rules" class="form-container">
              <el-form-item prop="name" label="员工姓名">
                <el-input v-model.trim="form.name" type="text" autocomplete="off" placeholder="请输入姓名" clearable />
              </el-form-item>
              <el-form-item prop="mobile" label="员工手机号码">
                <el-input
                  v-model.trim="form.mobile"
                  type="text"
                  autocomplete="off"
                  placeholder="请输入手机号码"
                  clearable
                  :readonly="dialogStatus === 'edit'"
                />
              </el-form-item>
              <el-form-item prop="vCode" label="验证码">
                <el-input
                  v-model.trim="form.vCode"
                  type="text"
                  autocomplete="off"
                  placeholder="请输入验证码"
                  clearable
                  class="code"
                  @keyup.enter.native="nextStep"
                />
                <el-button
                  type="primary"
                  class="code-btn"
                  :disabled="validPhone(form.mobile) || isShowCountDown"
                  :loading="isCodeLoading"
                  @click="getVerificationCode"
                >
                  {{ codeMsg }}
                </el-button>
              </el-form-item>

              <p class="forget-tips" @click="noSMSCode">验证码将发送到员工手机上，收不到短信验证码？</p>
            </el-form>
          </transition>
          <!-- 设定角色 -->
          <transition name="login-transform" mode="out-in">
            <div v-if="activeStep === 2" class="role-container">
              <p class="role-title">请分配员工角色，可点击查看 <span class="tips" @click="checkPermissionList">权限列表</span></p>
              <el-radio-group v-model="form.roleCodes">
                <el-radio
                  v-for="(item, index) in staffData.roles"
                  :key="index"
                  :label="item.roleCode"
                  class="role-item"
                >
                  <p class="one_txt_cut">{{ item.roleName }}</p>
                  <p class="remark one_txt_cut">{{ item.remark }}</p>
                </el-radio>
              </el-radio-group>
            </div>
          </transition>
          <!-- 分配门店 -->
          <transition name="login-transform" mode="out-in">
            <div v-if="activeStep === 3" class="store-container">
              <p class="role-title">请分配员工可访问的门店（可以多选）</p>
              <el-checkbox-group v-model="form.customerNos">
                <el-checkbox
                  v-for="(item, index) in staffData.customers"
                  :key="index"
                  :label="item.customerNumber"
                  class="role-item store-item"
                >
                  <p class="one_txt_cut">{{ item.customerNumber }} {{ item.programType }}</p>
                  <p class="one_txt_cut">{{ item.customerName }}</p>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </transition>
        </el-scrollbar>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button v-if="activeStep !== 1" type="primary" class="action-btn prev-btn" @click="prevStep">返回上一步</el-button>
      <el-button type="primary" class="action-btn next-btn" :disabled="isNextBtnDisabled" :loading="isNextLoading" @click="nextStep">{{ activeStep === 3 ? '提 交' : '下一步' }}</el-button>
    </span>

  </el-dialog>
</template>

<script>
import staticInfo from '@/helpers/staticInfo'
import { validPhone, validName } from '@/helpers/validate'

export default {
  name: 'AddUser',
  inject: ['userParent'],
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    dialogStatus: {
      type: String,
      default: 'create'
    },
    staffData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    const validateName = (rule, value, callback) => {
      if (!value || !validName(value)) {
        callback(new Error('姓名不包含特殊字符，只支持中文、英文和数字。'))
      } else if (this.errorKeys.indexOf('name') >= 0) {
        callback(new Error(this.errorInfo['name']))
        this.resetError('name')
      } else {
        callback()
      }
    }

    const validateMobile = (rule, value, callback) => {
      if (!value || validPhone(value)) {
        callback(new Error('请输入正确的手机号'))
      } else if (this.errorKeys.indexOf('mobile') >= 0) {
        callback(new Error(this.errorInfo['mobile']))
        this.resetError('mobile')
      } else {
        callback()
      }
    }

    const validateVcode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'))
      } else if (!this.form.vCodeFlag) {
        callback(new Error('请获取验证码'))
      } else if (this.errorKeys.indexOf('vCode') >= 0) {
        callback(new Error(this.errorInfo['vCode']))
        this.resetError('vCode')
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      activeStep: 1,
      form: {
        name: '',
        mobile: '',
        vCode: '',
        vCodeFlag: '',
        customerNos: [],
        roleCodes: ''
      },
      rules: {
        name: [{ required: true, trigger: ['change'], validator: validateName }],
        mobile: [{ required: true, trigger: ['change'], validator: validateMobile }],
        vCode: [{ required: true, trigger: ['change'], validator: validateVcode }]
      },
      validPhone: validPhone,
      errorKeys: [],
      errorInfo: {},
      timer: null,
      isShowCountDown: false,
      countDownNum: 60,
      isCodeLoading: false,
      isNextLoading: false,
      isNextBtnDisabled: false,
      submitFlag: true
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.isShow
      },
      set(val) {
        this.$emit('update:isShow', val)
      }
    },
    codeMsg() {
      if (this.isShowCountDown) {
        return `再次发送(${this.countDownNum})`
      } else {
        return '发送验证码'
      }
    },
    theme() {
      return this.$store.getters.theme
    }
  },
  watch: {
    isVisible(val) {
      if (val) {
        this.activeStep = 1
        this.isNextBtnDisabled = false
        if (this.dialogStatus === 'create') {
          this.form = {
            name: '',
            mobile: '',
            vCode: '',
            vCodeFlag: '',
            customerNos: [],
            roleCodes: ''
          }
        } else {
          this.form = {
            name: this.staffData.account.name,
            mobile: this.staffData.account.loginCode,
            vCode: '',
            vCodeFlag: '',
            customerNos: this.staffData.accountCustomerNumbers,
            roleCodes: this.staffData.accountRoleCodes[0]
          }
        }

        clearInterval(this.timer)
        this.countDownNum = 60
        this.isShowCountDown = false

        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      }
    }
  },
  methods: {
    noSMSCode() {
      const h = this.$createElement
      this.$msgbox({
        title: '',
        message: h('div', { style: 'text-align: justify' }, [
          h('span', null, '如果长时间没有收到验证码，您可以拨打'),
          h('i', { class: 'point' }, ` ${staticInfo.TP.Tel_HotLine} `),
          h('span', null, '咨询')
        ]),
        showCancelButton: false,
        center: true,
        customClass: 'dcp-message-box',
        confirmButtonClass: 'dcp-message-box-confirm-btn'
      }).then(action => {})
    },
    resetError(val) {
      if (val) {
        const index = this.errorKeys.indexOf(val)
        this.errorKeys.splice(index, 1)
        delete this.errorInfo.val
      } else {
        this.errorKeys = []
        this.errorInfo = {}
      }
    },
    getVerificationCode() {
      this.userParent.isBtnLoading = true
      this.isCodeLoading = true

      this.$api.login.getVCode({
        loginBizType: this.theme === 'tp' ? 'TP' : 'NT',
        mobile: this.form.mobile,
        businessType: 'BIZ_ACCOUNT',
        bizParam: { // 非必填, 编辑员工使用
          accountId: this.dialogStatus === 'create' ? '' : this.staffData.account.accountId
        }

      }).then(res => {
        this.userParent.isBtnLoading = false
        this.isCodeLoading = false
        this.form.vCodeFlag = res.data.vcodeFlag
        this.isShowCountDown = true

        this.timer = setInterval(() => {
          this.countDownNum--
          if (this.countDownNum <= 0) {
            clearInterval(this.timer)
            this.countDownNum = 60
            this.isShowCountDown = false
          }
        }, 1000)
      }).catch(err => {
        // 获取验证码失败
        clearInterval(this.timer)
        this.countDownNum = 60
        this.isShowCountDown = false
        this.userParent.isBtnLoading = false
        this.isCodeLoading = false

        if (err.errorInfos && err.errorInfos.length > 0) {
          this.resetError()
          err.errorInfos.forEach(item => {
            this.errorKeys.push(item.key)
            this.errorInfo[item.key] = item.errMsg
          })

          this.$refs['dataForm'].validate(valid => {
            console.log(valid)
          })
        }
      })
    },
    validVCode() {
      this.userParent.isLoading = true
      this.$api.login.validVCode({
        mobile: this.form.mobile,
        vCode: this.form.vCode,
        vCodeFlag: this.form.vCodeFlag

      }).then(res => {
        // this.userParent.isLoading = false

        this.userParent.getStaffOauth(this.form.mobile, 'create').then((res) => {
          const tmpRoleCodes = this.staffData.accountRoleCodes
          const tmpCustomers = this.staffData.accountCustomerNumbers

          if (tmpRoleCodes && tmpRoleCodes.length) {
            const tmpRoleArr = this.staffData.roles.filter(child => child.roleCode === tmpRoleCodes[0])
            if (tmpRoleArr.length) this.form.roleCodes = tmpRoleCodes[0]
          }

          if (tmpCustomers && tmpCustomers.length) {
            this.form.customerNos = []
            tmpCustomers.forEach(item => {
              const tmpArr = this.staffData.customers.filter(child => child.customerNumber === item)
              if (tmpArr.length) this.form.customerNos.push(item)
            })
          }

          this.$nextTick(() => {
            this.activeStep++
            this.userParent.isLoading = false
          })
        })
      }).catch(err => {
        this.userParent.isLoading = false

        if (err.errorInfos && err.errorInfos.length > 0) {
          this.resetError()
          err.errorInfos.forEach(item => {
            this.errorKeys.push(item.key)
            this.errorInfo[item.key] = item.errMsg
          })

          this.$refs['dataForm'].validate(valid => {
            console.log(valid)
          })
        }
      })
    },
    prevStep() {
      this.activeStep--
      if (this.activeStep === 1) {
        clearInterval(this.timer)
        this.countDownNum = 60
        this.isShowCountDown = false
        this.form.vCode = ''
        this.form.vCodeFlag = ''
      }
    },
    nextStep() {
      console.log(this.form)

      if (this.activeStep === 1) {
        this.$refs['dataForm'].validate((valid) => {
          if (!valid || !this.form.vCodeFlag) {
            // this.isNextBtnDisabled = true
          } else {
            this.validVCode()
            // this.activeStep++
          }
        })
      } else if (this.activeStep === 2) {
        if (this.form.roleCodes !== '') {
          this.activeStep++
        } else {
          this.$message.error('请选择角色')
        }
      } else if (this.activeStep === 3) {
        if (this.form.customerNos.length && this.submitFlag) {
          this.submitFlag = false
          this.userParent.isLoading = true
          const data = { ...this.form }
          data.roleCodes = [data.roleCodes]
          data.accountId = this.dialogStatus === 'create' ? '' : this.staffData.account.accountId

          this.$api.staff.saveStaffInfo(data).then(res => {
            this.submitFlag = true
            this.userParent.isLoading = false
            this.userParent.fetchList()

            this.$nextTick(() => {
              if (this.dialogStatus === 'edit') {
                this.gtag('event', 'usr_edit_staff_success')
                this.userParent.isShowStaffInfo = false
              } else {
                this.gtag('event', 'usr_add_staff_success')
              }
              this.isVisible = false
            })
          }).catch(() => {
            this.submitFlag = true
            this.userParent.isLoading = false
          })
        } else {
          this.$message.error('请选择门店')
          this.submitFlag = true
        }
      }
    },
    checkPermissionList() {
      this.userParent.isShowPermissionList = true
    }
  }
}
</script>

<style lang="scss" scoped>
.el-steps {
  /deep/.el-step__head {
    .el-step__line {
      @include background_color_page_primary('bg-color-light');
    }

    .el-step__icon {
      color: #fff;

      @include background_color_page_primary('bg-color-light');
      @include border_color_page_primary('bg-color-light');
    }

    &.is-finish {
      .el-step__line {
        @include background_color_page_primary('bg-color-light');
      }

      .el-step__icon {
        @include background_color_page_primary('color');
        @include border_color_page_primary('color');
      }

      @include color_page_primary('color');
      @include border_color_page_primary('color');
    }
  }

  /deep/.el-step__title {
    &.is-finish {
      @include color_page_primary('color');
    }

    @include color_page_primary('bg-color-light');
  }
}

.inner-wrap {
  height: 400px;
  overflow: auto;

  /deep/ .el-scrollbar__wrap {
    box-sizing: border-box;
    max-height: 400px;
    // padding-right: 16px;
    margin-bottom: 0 !important;
    overflow-x: hidden;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;

  .action-btn {
    width: 48%;
    height: 49px;
    font-size: 16px;

    + .next-btn {
      margin-left: 4%;
    }
  }

  .next-btn {
    @include btn_page_primary('color');
  }

  .prev-btn {
    @include login_channel_icon('color');
  }
}

.form-container {
  position: relative;
  width: 100%;
  padding-top: 40px;

  /deep/ .el-form-item {
    .el-form-item__label {
      width: 100%;
      padding: 0;
      font-size: 14px;
      text-align: left;

      &::before {
        content: '';
      }

      @include color_page_primary('font-color-diff');
    }

    .el-input__inner {
      padding: 0;
      border: none;
      border-bottom-width: 1px;
      border-bottom-style: solid;
      border-radius: 0;

      @include border_color_page_primary("font-color-diff");
    }

    // 更改clear图标
    .el-input__suffix {
      .el-icon-circle-close {
        font-size: 20px;

        &::before {
          content: "\e6db";
        }

        @include color_page_primary("font-color-diff");
      }
    }
  }

  .forget-tips {
    // position: absolute;
    // bottom: -41px;
    // right: 0;
    font-size: 14px;
    text-align: right;
    cursor: pointer;

    @include color_page_primary('font-color-diff');
  }

  .code {
    box-sizing: border-box;
    width: 54%;
    margin-right: 6%;
  }

  .code-btn {
    width: 40%;

    @include btn_page_primary('color');
  }
}

.role-container,
.store-container {
  .role-title {
    font-size: 14px;
    line-height: 60px;

    .tips {
      cursor: pointer;

      @include color_page_primary('color');
    }
  }

  .el-radio-group {
    width: 100%;
  }

  .role-item {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    height: 77px;
    padding: 0 20px;
    margin-right: 0;
    border: 1px solid;
    border-radius: 4px;

    + .role-item {
      margin-top: 10px;
    }

    /deep/.el-checkbox__label,
    /deep/.el-radio__label {
      // flex: 1;
      flex-grow: 1;
      padding-left: 0;
      overflow: hidden;
      font-size: 16px;
      line-height: 1.6;
      text-align: left;

      .remark {
        font-size: 14px;
      }

      @include color_page_primary('font-color-diff');
    }

    /deep/.el-checkbox__inner {
      width: 20px;
      height: 20px;

      &:hover {
        @include border_color_page_primary('color');
      }

      &::after {
        left: 6px;
        width: 5px;
        height: 10px;
      }
    }

    /deep/.el-radio__inner {
      width: 20px;
      height: 20px;

      &:hover {
        @include border_color_page_primary('color');
      }

      &::after {
        width: 6px;
        height: 6px;
      }
    }

    &.is-checked {
      /deep/.el-checkbox__inner,
      /deep/.el-radio__inner {
        @include background_color_page_primary('color');
        @include border_color_page_primary('color');
      }

      @include border_color_page_primary('color');
    }

    @include border_color_page_primary('bg-color-light');
    @include background_color_page_primary('bg-color-light');
  }
}
</style>
